import React from 'react';
import BorrowerDashBannerSC, {
  BannerMainStatsSC,
  BannerSliderWrapSC,
} from './borrower-dash-banner.styled';
import numeral from 'numeral';
import { HeadingTwo, HeadingFour, BodyText, SmallText, HeadingThree } from '../typography';
import Button from '../ui/button';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import Slider from 'react-slick';
import { BP_TABLET_MIN } from '../../assets/styles/breakpoints';
import useWindowSize from '../../utils/screen-size';
import InlineLoading from '../ui/inline-loading';

const BorrowerDashBanner = ({ bannerData }) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;

  const formatIban = (iban) => {
    if (iban !== '' && iban !== null) {
      return iban.replace(/(.{4})/g, '$1 ');
    } else {
      return '-';
    }
  };

  const formatVarNumber = (vNum) => {
    return ('000000000' + vNum).slice(-9);
  };

  const formatLastPaymentDate = () => {
    let bankTransactions = bannerData.loans[0].bankTransactions;
    if (bankTransactions && bankTransactions.length > 0) {
      const filteredTransactions = bankTransactions.filter((item) => item.accountType.id === 1007);
      if (filteredTransactions.length > 0) {
        return (
          <SmallText className="dark-grey">
            <FormattedMessage
              id="borrower_dash_banner_card_last_payment"
              defaultMessage={dlt['borrower_dash_banner_card_last_payment']}
            />
            {filteredTransactions[0].date}
          </SmallText>
        );
      } else {
        return (
          <SmallText className="dark-grey">
            <FormattedMessage
              id="borrower_dash_banner_card_no_last_payment"
              defaultMessage={dlt['borrower_dash_banner_card_no_last_payment']}
            />
          </SmallText>
        );
      }
    } else {
      return (
        <SmallText className="dark-grey">
          <FormattedMessage
            id="borrower_dash_banner_card_no_last_payment"
            defaultMessage={dlt['borrower_dash_banner_card_no_last_payment']}
          />
        </SmallText>
      );
    }
  };

  const settings = {
    infinite: false,
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 1,
    mobileFirst: true,
    slidesToScroll: 1,
    variableWidth: true,
    variableHeight: true,
  };

  if (Object.keys(bannerData).length === 0) {
    return (
      <BorrowerDashBannerSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </BorrowerDashBannerSC>
    );
  }

  return (
    <BorrowerDashBannerSC>
      <div className="left-wrap">
        <HeadingTwo className="white left-wrap--main-headline">
          <FormattedMessage
            id="borrower_dash_banner_headline"
            defaultMessage={dlt['borrower_dash_banner_headline']}
          />
        </HeadingTwo>
        <HeadingFour className="white left-wrap--sub-headline">
          <FormattedMessage
            id="borrower_dash_banner_sub_headline"
            defaultMessage={dlt['borrower_dash_banner_sub_headline']}
          />
        </HeadingFour>
        <Button type="LINK">{formatIban(bannerData.portalIBAN)}</Button>
        {bannerData.loans[0].wmNumber !== null ? (
          <SmallText className="grey">
            <FormattedMessage
              id="borrower_dash_banner_variable_symbol"
              defaultMessage={dlt['borrower_dash_banner_variable_symbol']}
            />{' '}
            {formatVarNumber(bannerData.loans[0].wmNumber)}
          </SmallText>
        ) : null}
      </div>
      <div className="right-wrap">
        <BodyText className="grey bolder">
          <FormattedMessage
            id="borrower_dash_banner_overview_loan"
            defaultMessage={dlt['borrower_dash_banner_overview_loan']}
          />
        </BodyText>
        {isTablet ? (
          <BannerSliderWrapSC>
            <Slider {...settings}>
              <div className="col">
                <SmallText className="grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_amount_loan"
                    defaultMessage={dlt['borrower_dash_banner_card_amount_loan']}
                  />
                </SmallText>
                <HeadingThree className="white">
                  {numeral(Number(bannerData.loans[0].amount)).format('0,00.00')} €
                </HeadingThree>
                <SmallText className="dark-grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_to_date"
                    defaultMessage={dlt['borrower_dash_banner_card_to_date']}
                  />{' '}
                  {bannerData.loans[0].schedules[bannerData.loans[0].schedules.length - 1][1]}
                </SmallText>
              </div>
              <div className="col">
                <SmallText className="grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_paid"
                    defaultMessage={dlt['borrower_dash_banner_card_paid']}
                  />
                </SmallText>
                <HeadingThree className="white">
                  {numeral(Number(bannerData.loans[0].status.totalPaid)).format('0,00.00')} €
                </HeadingThree>
                {formatLastPaymentDate()}
              </div>
              <div className="col">
                <SmallText className="grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_balance_to_pay"
                    defaultMessage={dlt['borrower_dash_banner_card_balance_to_pay']}
                  />
                </SmallText>
                <HeadingThree className="dark-grey">
                  {numeral(Number(bannerData.loans[0].status.totalUnpaid)).format('0,00.00')} €
                </HeadingThree>
                <SmallText className="dark-grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_commitment"
                    defaultMessage={dlt['borrower_dash_banner_card_commitment']}
                  />
                </SmallText>
              </div>
              <div className="col">
                <SmallText className="grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_installment_height"
                    defaultMessage={dlt['borrower_dash_banner_card_installment_height']}
                  />
                </SmallText>
                <HeadingThree className="orange">
                  {bannerData.loans[0].status.nextInstallmentAmount !== '-'
                    ? `${numeral(Number(bannerData.loans[0].status.nextInstallmentAmount)).format(
                        '0,00.00'
                      )} €`
                    : '-'}
                </HeadingThree>
                <SmallText className="dark-grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_actual_installment"
                    defaultMessage={dlt['borrower_dash_banner_card_actual_installment']}
                  />{' '}
                  {bannerData.loans[0].status.nextInstallmentDate !== '-'
                    ? bannerData.loans[0].status.nextInstallmentDate
                    : '-'}
                </SmallText>
              </div>
            </Slider>
          </BannerSliderWrapSC>
        ) : (
          <BannerMainStatsSC>
            <div className="col">
              <SmallText className="grey">
                <FormattedMessage
                  id="borrower_dash_banner_card_amount_loan"
                  defaultMessage={dlt['borrower_dash_banner_card_amount_loan']}
                />
              </SmallText>
              <HeadingThree className="white">
                {numeral(Number(bannerData.loans[0].amount)).format('0,00.00')} €
              </HeadingThree>
              <SmallText className="dark-grey">
                <FormattedMessage
                  id="borrower_dash_banner_card_to_date"
                  defaultMessage={dlt['borrower_dash_banner_card_to_date']}
                />{' '}
                {bannerData.loans[0].schedules[bannerData.loans[0].schedules.length - 1][1]}
              </SmallText>
            </div>
            <div className="col">
              <SmallText className="grey">
                <FormattedMessage
                  id="borrower_dash_banner_card_paid"
                  defaultMessage={dlt['borrower_dash_banner_card_paid']}
                />
              </SmallText>
              <HeadingThree className="white">
                {numeral(Number(bannerData.loans[0].status.totalPaid)).format('0,00.00')} €
              </HeadingThree>
              {formatLastPaymentDate()}
            </div>
            <div className="col">
              <SmallText className="grey">
                <FormattedMessage
                  id="borrower_dash_banner_card_balance_to_pay"
                  defaultMessage={dlt['borrower_dash_banner_card_balance_to_pay']}
                />
              </SmallText>
              <HeadingThree className="dark-grey">
                {numeral(Number(bannerData.loans[0].status.totalUnpaid)).format('0,00.00')} €
              </HeadingThree>
              <SmallText className="dark-grey">
                <FormattedMessage
                  id="borrower_dash_banner_card_commitment"
                  defaultMessage={dlt['borrower_dash_banner_card_commitment']}
                />
              </SmallText>
            </div>
            <div className="col">
              <SmallText className="grey">
                <FormattedMessage
                  id="borrower_dash_banner_card_installment_height"
                  defaultMessage={dlt['borrower_dash_banner_card_installment_height']}
                />
              </SmallText>
              <HeadingThree className="orange">
                {bannerData.loans[0].status.nextInstallmentAmount !== '-'
                  ? `${numeral(Number(bannerData.loans[0].status.nextInstallmentAmount)).format(
                      '0,00.00'
                    )} €`
                  : '-'}
              </HeadingThree>
              <SmallText className="dark-grey">
                <FormattedMessage
                  id="borrower_dash_banner_card_actual_installment"
                  defaultMessage={dlt['borrower_dash_banner_card_actual_installment']}
                />{' '}
                {bannerData.loans[0].status.nextInstallmentDate !== '-'
                  ? bannerData.loans[0].status.nextInstallmentDate
                  : '-'}
              </SmallText>
            </div>
            {bannerData.loans[0]?.refinancing ? (
              <div className="col">
                <SmallText className="grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_refinance"
                    defaultMessage={dlt['borrower_dash_banner_card_refinance']}
                  />
                </SmallText>
                <HeadingThree className="white">
                  {bannerData.loans[0]?.refinanceAmount} €
                </HeadingThree>
                <SmallText className="dark-grey">
                  <FormattedMessage
                    id="borrower_dash_banner_card_refinance_count"
                    defaultMessage={dlt['borrower_dash_banner_card_refinance_count']}
                    values={{ count: bannerData.loans[0]?.refinanceCount }}
                  />
                </SmallText>
              </div>
            ) : null}
          </BannerMainStatsSC>
        )}
      </div>
    </BorrowerDashBannerSC>
  );
};

export default BorrowerDashBanner;
